'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ApiMenuSectionSubItem = _react2['default'].createClass({
    displayName: 'ApiMenuSectionSubItem',


    propTypes: {
        title: _react2['default'].PropTypes.string.isRequired,
        reference: _react2['default'].PropTypes.string.isRequired,
        url: _react2['default'].PropTypes.string.isRequired,
        isInitiallyActive: _react2['default'].PropTypes.bool
    },

    getInitialState: function getInitialState() {
        return {
            'isActive': this.props.isInitiallyActive
        };
    },

    componentWillReceiveProps: function componentWillReceiveProps(newProps) {
        this.setState({
            'isActive': newProps.isInitiallyActive
        });
    },

    render: function render() {

        var classes = (0, _classnames2['default'])({
            'l-api-docs-menu--sub-items--sub-item': true,
            'is-active': this.state.isActive
        });

        return _jsx('div', {
            className: classes,
            'data-ref': this.props.reference
        }, void 0, _jsx('a', {
            href: this.props.url
        }, void 0, this.props.title));
    }
});

module.exports = ApiMenuSectionSubItem;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/api-docs/api-menu/section-sub-item.jsx
 ** module id = 731
 ** module chunks = 0
 **/